import { AddressCollectionSchema } from "@redotech/redo-return-core-common/address-collection";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getAddressCollectionsForTeam = unaryRpc({
  name: "getAddressCollectionsForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ addresses: z.array(AddressCollectionSchema) }),
});
